import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { Link } from '@savgroup-front-common/core/atoms/link';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $SimpleCardContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  display: flex;
  flex-direction: column;
  @media ${media.minWidth.sm} {
    flex-direction: row;
    padding: ${spacing('xl')};
    align-items: center;
  }
  padding: ${spacing('md')};
  margin-bottom: ${spacing(7)};
  align-items: flex-start;
`;

export const $SimpleCardIcon = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${spacing(2.5)};
  & svg {
    width: ${spacing('xl')};
    height: auto;
  }
  @media ${media.minWidth.sm} {
    margin-right: ${spacing('lg')};
    & svg {
      width: ${spacing('xxl')};
      height: ${spacing('xxl')};
    }
  }
`;

interface SimpleCardInfoContainerProps {
  hasDidactics?: boolean;
}

export const $SimpleCardInfoContainer = styled.div<SimpleCardInfoContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ hasDidactics }) =>
    hasDidactics ? spacing('sm') : 'unset'};
  @media ${media.maxWidth.sm} {
    margin-bottom: ${spacing('lg')};
    justify-content: flex-start;
  }
`;

export const $SimpleCardPrefixTitle = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${fontWeight('medium')};
  ${fontStyle('base')};
`;

export const $SimpleCardTitle = styled.span`
  color: ${({ theme }) => theme.colors.mainTextColor};
  font-weight: ${fontWeight('normal')};
  ${fontStyle('base')};
`;

export const $SimpleCardLink = styled(Link)`
  font-weight: ${fontWeight('normal')};
  ${fontStyle('sm')};
  display: flex;
  align-items: center;
  text-align: right;
  text-decoration-line: underline;
  color: ${({ theme }) => theme.colors.mainTextColor};
`;

export const $SimpleCardDidactic = styled.div`
  width: 80%;
  font-weight: ${fontWeight('normal')};
  ${fontStyle('sm')};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  margin-top: ${spacing('sm')};
  margin-bottom: ${spacing('sm')};
  @media ${media.maxWidth.sm} {
    width: 100%;
  }
`;

export const $PriceColumn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: ${spacing('sm')};
`;

export const $SimpleCardDetail = styled.div`
  text-align: left;
  ${fontStyle('base')};
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${fontWeight('medium')};

  @media ${media.minWidth.sm} {
    line-height: 19px;
  }
`;

export const $IsDeductibleBlock = styled.div`
  text-align: left;
  ${fontStyle('base')};
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${fontWeight('medium')};
`;

export const $SimpleCardAddressName = styled.div`
  display: block;
  color: ${({ theme }) => theme.colors.mainTextColor};
  font-weight: ${fontWeight('medium')};
  ${fontStyle('sm')};
`;

export const $SimpleCardAddressNameContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.disabled};
  margin-top: ${spacing(3.5)};
  padding-top: ${spacing(3.5)};
  margin-bottom: ${spacing(3.5)};
  display: flex;
  gap: ${spacing('xs')};
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const $SimpleCardTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
